<template>
    <div class="mt-2">
        <b-container class="container-lg">
            <b-row class="pb-2">
                <b-col class="text-start">
                    <h5><i class="fa-solid fa-gauge-high"></i> {{ $t('Dashboard') }}</h5>
                </b-col>
                <b-col class="text-end">
                </b-col>
            </b-row>
            <b-card class="mb-2 border-bottom-1 rounded-bottom-1">
                <div class="row">
                    <b-button-group class="w-100">
                        <button class="w-100 btn btn-light"
                                type="button"
                                @click="pushTo('dashboardsIndex')">
                            <i class="fa-solid fa-layer-group"></i>
                            {{ $t('Overview') }}
                        </button>
                        <!--<button type="button"
                                class="w-50 btn btn-light"
                                @click="pushTo('dashboardsStatuspagegroups')">
                          <i class="fa-solid fa-layer-group"></i>
                          {{ $t('Slas') }}
                        </button>-->
                    </b-button-group>
                </div>
                <div class="row">
                    <b-button-group class="w-100">
                        <button class="w-50 btn btn-primary"
                                type="button"
                                @click="pushTo('dashboardsAlerts')">
                            <i class="fa-solid fa-bell"></i>
                            {{ $t('Alerts') }}
                        </button>
                        <button class="w-50 btn btn-light"
                                type="button"
                                @click="pushTo('dashboardsTacticals')">
                            <i class="fa-solid fa-chart-area"></i>
                            {{ $t('Tacticals') }}
                        </button>

                    </b-button-group>
                </div>
                <div class="row">
                    <b-button-group class="w-100">
                        <button class="w-50 btn btn-light"
                                type="button"
                                @click="pushTo('dashboardsStatuspages')">
                            <i class="fa-solid fa-info-circle"></i>
                            {{ $t('Statuspages') }}
                        </button>
                        <button class="w-50 btn btn-light"
                                type="button"
                                @click="pushTo('dashboardsStatuspagegroups')">
                            <i class="fa-solid fa-layer-group"></i>
                            {{ $t('Statuspage groups') }}
                        </button>
                    </b-button-group>
                </div>
            </b-card>
            <b-row class="pb-2">
                <b-col class="text-start">
                    <h6>{{ $t('Top') }} {{ $t('alerts') }}</h6>
                    <div class="small">{{ $t('last 24 hours') }}</div>
                </b-col>
            </b-row>
            <b-card class="border-bottom-1 rounded-bottom-1 mb-2">
                <b-button-group class="w-100">
                    <button class="btn btn-light"
                            type="button"
                            @click="pushTo('dashboardsAlerts')">
                        <i class="fa-solid fa-server"></i>
                        {{ $t('Hosts') }}
                    </button>
                    <button class="btn btn-primary"
                            type="button"
                            @click="pushTo('dashboardsAlertsServices')">
                        <i class="fa-solid fa-cogs"></i>
                        {{ $t('Services') }}
                    </button>
                </b-button-group>
            </b-card>

            <div>
                <b-card-group class="pb-2" deck>
                    <service-alert-widget :state="'unknown'"/>
                    <service-alert-widget :state="'critical'"/>
                </b-card-group>
                <b-card-group deck>
                    <service-alert-widget :state="'warning'"/>
                    <service-alert-widget :state="'ok'"/>
                </b-card-group>
            </div>
        </b-container>
    </div>
</template>
<script>
import ServiceAlertWidget from './dashboard/ServiceAlertWidget.vue';

export default {
    name: "DashboardsAlertsServices",

    components: {
        ServiceAlertWidget
    },

    data() {
        return {}
    },

    methods: {
        pushTo(route) {
            this.$router.push({name: route});
        }
    }
}
</script>

<style scoped>

</style>